<template>
  <validation-provider
    v-slot="{ errors, reset }"
    class="validate-tooltip grid-x"
    :name="String(fieldName).toLowerCase()"
    :rules="rules"
    :vid="$props.id || $attrs.id"
    mode="eager"
  >
    <text-area
      v-model="localValue"
      v-bind="{ ...$props, ...$attrs }"
      v-on="$listeners"
    />
    <transition name="fade">
      <span
        v-if="errors[0]"
        class="cell shrink error popover"
        tabindex="0"
        @click="reset()"
        v-text="errors[0]"
      />
    </transition>
  </validation-provider>
</template>

<script>
export default {
  name: 'TextareaWithValidation',
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default: () => `tx_${Math.random().toString(12).substring(2, 8)}`,
    },
    rules: {
      type: [ String, Array, Object ],
      default: '',
    },
    value: {
      type: [ String, Number ],
      default: '',
    },
  },
  computed: {
    fieldName() {
      return this.$attrs['data-vv-as'] || this.$props.name || this.$attrs.placeholder;
    },
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
};
</script>
